import React from "react";

export const Nodata = () => {
  return <div>Nodata</div>;
};
